import { faRight } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, FormDecidable } from "bm-ui-kit";
import React from "react";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";

export interface StepFields {
	isAttendingHigherEducation: boolean;
	hasHigherEducationQualification: boolean;
	has3MonthsLegalHealthInsurance: boolean;
	hasMoreThan5kTaxDebt: boolean;
	hasHungarianAddress: boolean;
	isOnBadDebtorsList: boolean;
}

export class Step2 extends AbstractStep<StepFields> {
	protected initValues(): StepFields {
		return {
			isAttendingHigherEducation: undefined,
			hasHigherEducationQualification: undefined,
			has3MonthsLegalHealthInsurance: undefined,
			hasMoreThan5kTaxDebt: undefined,
			hasHungarianAddress: undefined,
			isOnBadDebtorsList: undefined,
		};
	}

	protected renderContent(): ReactNode {
		const disabled = this.isDisabled();

		return (
			<>
				<Card.Body>
					<FormDecidable
						label="Felsőoktatási intézmény tanulója vagy?"
						name="isAttendingHigherEducation"
						className="mt-4"
						disabled={disabled}
						required
					/>
					<FormDecidable
						label="Van főiskolai, egyetemi diplomád?"
						name="hasHigherEducationQualification"
						className="my-4"
						disabled={disabled}
						required
					/>
					<FormDecidable
						label="Van 3 hónapos TB jogviszonyod?"
						name="has3MonthsLegalHealthInsurance"
						disabled={disabled}
						required
					/>
					<FormDecidable
						label="Van 5 ezer Ft-ot meghaladó adótartozásod, köztartozásod?"
						name="hasMoreThan5kTaxDebt"
						className="my-4"
						disabled={disabled}
						required
					/>
					<FormDecidable
						label="Van magyar lakcímed?"
						name="hasHungarianAddress"
						disabled={disabled}
						required
					/>
					<FormDecidable
						label="Szerepelsz a rossz adósok listáján (KHR lista)?"
						name="isOnBadDebtorsList"
						className="my-4"
						disabled={disabled}
						required
					/>
				</Card.Body>
				<Card.Footer className="text-center">
					<Button
						type="submit"
						icon={<FontAwesomeIcon icon={faRight} />}
						className="text-uppercase text-white"
						variant="primary"
					>
						Tovább
					</Button>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "Step2";
	}
}
